import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format() {
    // Add commas to the number
    parseFloat(this.element.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
}
